module.exports = __webpack_public_path__ + "img/ring_g_skip_null_0@2x.f13145e0.png";